import { StoryblokComponent } from '@storyblok/react'
import { CheckIcon } from 'ui/src/icons/CheckIcon'
import { xStack, yStack } from 'ui/src/patterns/stack'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { filterByBlockType } from '@/services/storyblok/Storyblok.helpers'
import { TextBlock, type TextBlockProps } from '../TextBlock/TextBlock'

type CoverageListBlockProps = SbBaseBlockProps<{
  items: ExpectedBlockType<TextBlockProps>
}>

export function CoverageListBlock({ blok }: CoverageListBlockProps) {
  // Being extra cautious here, but we know that the only block type we're expecting is 'text'
  const items = filterByBlockType(blok.items, TextBlock.blockName)

  return (
    <ul className={yStack({ gap: 'xs' })}>
      {items.map((nestedBlock) => (
        <li key={nestedBlock._uid} className={xStack({ gap: 'xs', alignItems: 'center' })}>
          <CheckIcon size="1.125rem" />
          <StoryblokComponent blok={nestedBlock} nested={true} />
        </li>
      ))}
    </ul>
  )
}
